var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCogs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02922 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H8.02922C7.38332 19 6.77718 18.6881 6.40176 18.1625L2.83033 13.1625C2.33362 12.4671 2.33362 11.5329 2.83033 10.8375L6.40176 5.83752C6.77718 5.31193 7.38332 5 8.02922 5ZM11.5303 8.46967C11.2374 8.17678 10.7625 8.17678 10.4697 8.46967C10.1768 8.76256 10.1768 9.23744 10.4697 9.53033L12.9393 12L10.4697 14.4697C10.1768 14.7626 10.1768 15.2374 10.4697 15.5303C10.7625 15.8232 11.2374 15.8232 11.5303 15.5303L14 13.0607L16.4697 15.5303C16.7626 15.8232 17.2374 15.8232 17.5303 15.5303C17.8232 15.2374 17.8232 14.7626 17.5303 14.4697L15.0606 12L17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L14 10.9393L11.5303 8.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogs1);
export default __webpack_public_path__ + "static/media/cogs-1.1832a189db2cc0a81fd000d673ffb134.svg";
export { ForwardRef as ReactComponent };